import { Box, styled } from "@mui/material"

export const List = styled(Box)(({ theme }) => ({
    borderTop: '1px solid #E5E5E7',
    borderBottom: '1px solid #E5E5E7',
    ':hover': {
        background: '#EFFFF7'
    },
    '.item-list': {        
        // borderTop: '1px solid',
        cursor: 'pointer',
        padding: '12px',
       
        '.icon-list': {
            marginRight: '12px'
        }
    },

}))
export const ItemList = styled(Box)(({ theme }) => ({
    width:"87%"
}))